module.exports = __webpack_public_path__ + "static/media/tot_prv-grey.1caf951e.svg";